import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
    City,
    PackageSizeAndWeightType,
    ParcelSizeType,
    ShippingCosts,
    ValidationType,
} from '@/lib/type/type';

interface StateStore {
    allParametersSelected: ShippingCosts | null;
    parcelSizes: ParcelSizeType[];
    validation: ValidationType;
    exactPackageSize: PackageSizeAndWeightType;
    selectedCity: ShippingCosts;
    selectedFrom: string;
    selectedTo: string;
    departureSuggestions: City[];
    destinationSuggestions: City[];
    showDepartureSuggestions: boolean;
    showDestinationSuggestions: boolean;
}

const initialState: StateStore = {
    allParametersSelected: null,
    parcelSizes: [],
    exactPackageSize: {
        name: 'Точный размер',
        length: '',
        width: '',
        height: '',
        weight: '',
    },
    validation: {
        from: false,
        to: false,
    },
    selectedCity: {
        from: [],
        to: [],
        size: null,
    },
    selectedFrom: '',
    selectedTo: '',
    departureSuggestions: [],
    destinationSuggestions: [],
    showDepartureSuggestions: false,
    showDestinationSuggestions: false,
};

const calculatorStore = createSlice({
    name: 'calculatorStore',
    initialState,
    reducers: {
        getCityCode: (state, action: PayloadAction<{ type: 'from' | 'to'; data: City[] }>) => {
            const { type, data } = action.payload;
            if (type === 'from') {
                state.selectedCity.from = data;
            } else {
                state.selectedCity.to = data;
            }
        },
        getCityCodeSize(state, action: PayloadAction<ParcelSizeType>) {
            if (!action.payload?.dimensions_cm) return;

            const [length, height, width] = action.payload.dimensions_cm.split('x').map(Number);
            state.selectedCity.size = {
                name: action.payload.name,
                length,
                width,
                height,
                weight: action.payload.weight_limit_kg,
            };
        },
        getCityCodeSizesAccurate(state, action: PayloadAction<PackageSizeAndWeightType>) {
            const size = {
                name: action.payload.name,
                length: action.payload.length,
                width: action.payload.width,
                height: action.payload.height,
                weight: action.payload.weight,
            };

            state.selectedCity.size = size;
            state.exactPackageSize = size;
        },
        clearCityCodeSizesAccurate(state) {
            state.exactPackageSize = {
                name: 'Точный размер',
                length: '',
                width: '',
                height: '',
                weight: '',
            };
        },
        selectedAllParams: (state, action: PayloadAction<ShippingCosts>) => {
            state.allParametersSelected = action.payload;
        },
        setValidation(state, action: PayloadAction<ValidationType>) {
            state.validation = action.payload;
        },
        setValidationInput(state, action: PayloadAction<keyof ValidationType>) {
            state.validation[action.payload] = false;
        },
        getParcelSizes(state, action) {
            state.parcelSizes = action.payload;
        },
        setDeparture(state, action: PayloadAction<string>) {
            state.selectedFrom = action.payload;
        },
        setDestination(state, action: PayloadAction<string>) {
            state.selectedTo = action.payload;
        },
        setDepartureSuggestions(state, action: PayloadAction<City[]>) {
            state.departureSuggestions = action.payload;
        },
        setDestinationSuggestions(state, action: PayloadAction<City[]>) {
            state.destinationSuggestions = action.payload;
        },
        setShowDepartureSuggestions(state, action: PayloadAction<boolean>) {
            state.showDepartureSuggestions = action.payload;
        },
        setShowDestinationSuggestions(state, action: PayloadAction<boolean>) {
            state.showDestinationSuggestions = action.payload;
        },
    },
});

export const {
    selectedAllParams,
    getCityCode,
    setValidation,
    getCityCodeSize,
    getParcelSizes,
    setValidationInput,
    setDeparture,
    setDestination,
    setDepartureSuggestions,
    setDestinationSuggestions,
    setShowDepartureSuggestions,
    setShowDestinationSuggestions,
    getCityCodeSizesAccurate,
    clearCityCodeSizesAccurate,
} = calculatorStore.actions;
export default calculatorStore.reducer;
